import { FieldProps } from "formik";
import Select from "react-select";

export const dropdown = <S extends any>(values: readonly S[], formatter: (value: S) => string) => <T extends object>(formik: FieldProps<any, T>) => {
  const value = formik.field.value;
  return (
    <Select
      options={values.map(value => ({ value, label: formatter(value) }))}
      defaultValue={{ value, label: formatter(value) }}
      onChange={(e) =>
        formik.form.setFieldValue(formik.field.name as string, e?.value)
      }
      menuPlacement="top"
    />
  );
};